import { useState, useEffect } from "react";
import axios from "axios";

const apiUrl = "https://elcobradorleague.com/api";

export const usePlayerLeagues = (idplayer) => {
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!idplayer) {
      setLeagues([]);
      setLoading(false);
      return;
    }

    const controller = new AbortController();

    const fetchLeagues = async () => {
      try {
        const res = await axios.get(
          `${apiUrl}/api.php?endpoint=player_leagues&idplayer=${idplayer}`,
          {
            headers: {
          'X-API-TOKEN': process.env.REACT_APP_API_TOKEN
        },
            signal: controller.signal
          }
        );

        setLeagues(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        setLeagues([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLeagues();
    return () => controller.abort();
  }, [idplayer]);

  return { leagues, loading };
};

